import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { ADMIN_HOME, WORKER_HOME, type AppSection } from "@/lib/app-sidebar";

export interface SectionSwitcherProps {
  section: AppSection;
  size?: "compact" | "default";
  targetLabel?: string;
}

export function SectionSwitcher({ section, size = "default", targetLabel }: SectionSwitcherProps) {
  const { t } = useTranslation();
  const target = section === "admin" ? WORKER_HOME : ADMIN_HOME;
  const label =
    section === "admin" ? t("common.nav.work.label") : (targetLabel ?? t("common.nav.admin.label"));
  return (
    <Link
      to={target}
      className={
        size === "compact"
          ? "inline-flex items-center gap-1 rounded-3 px-1.5 py-1 text-[12px] text-ink-700 hover:bg-surface-1 hover:text-ink-900"
          : "inline-flex items-center gap-1 rounded-3 px-2 py-1 text-[12.5px] text-ink-700 hover:bg-surface-1 hover:text-ink-900"
      }
    >
      <span>{label}</span>
      <ArrowRight size={14} className="text-ink-500" />
    </Link>
  );
}
